import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

const RightLink = ({ name, onClick, marginTop = 0 }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'flex-end',
        justifyContent: 'right',
        paddingLeft: 30,
        paddingRight: 30,
        marginTop: marginTop,
      }}
    >
      <Typography
        variant="p"
        component="p"
        style={{ textDecoration: 'underline', color: 'blue', fontSize: 15, cursor: 'pointer' }}
        onClick={onClick}
      >
        {name}
      </Typography>
    </div>
  );
};

RightLink.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string,
  marginTop: PropTypes.number,
};

export default RightLink;
